import {IObjectData, IOrganization, IOverride, ISystemPermission} from "../../../index";
import {Organization} from "./Organization";

type TSystemPermissionStatus = 'unchanged' | 'new' | 'changed' | 'deleted' | 'restored'

interface ISubmitDataOverride {
    old: IOverride | null
    new: IOverride | null
    status: TSystemPermissionStatus
}

interface IOrganizationParams {
    organization: IOrganization
    systemPermission: ISystemPermission
    user: IObjectData
}

interface ISystemPermissionParams {
    mo: Organization
    user: IObjectData
    sp: ISystemPermission
    override: IOverride
}